import { createMasterEditView } from "../../viewComponents/masterEditView";

export default createMasterEditView(
  "planiumChemicalMasterEditView",
  "マスタ編集ビュー",
  [
    "purchasePlan",
    "shippingPlan",
    "batchTaskPlan",
    "salesInput",
    "itemMaster",
    "stockCriteriaMaster",
    "rawMaterialMaster",
    "bomMaster",
    "bomRawMaterialMaster",
    "bomByproductItemMaster",
    "deviceMaster",
    "storageMaster",
    "storageItemMaster",
    "batchTaskMaster",
    "switchingBatchTaskMaster",
    "linkTaskMaster",
    "businessDayCalendar",
    "adjustmentInput",
    "deviceMaintenanceInput",
    "memo",
    "bitMaskToPeopleCountMaster",
    "batchTaskToPeopleCountMaster",
    "params",
    "pluginMaster",
    "scoreSummaries",
    "commonStoragePluginMaster",
    "nonBusinessDayAdjacentTaskPluginMaster",
    "taskPriorityPluginMaster",
    "approvalRecord",
    "approverMaster",
  ],
  []
);
